(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-info"] && !Shopify.designMode) return;
  try {
    class ShippingInfo extends HTMLElement {
    connectedCallback() {
      this.renderDeliveryDate();
    }

    addBusinessDays(startDate, days) {
      const date = new Date(startDate);
      let added = 0;
      while (added < days) {
        date.setDate(date.getDate() + 1);
        const dayOfWeek = date.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          added++;
        }
      }
      return date;
    }

    renderDeliveryDate() {
      const minDays = parseInt(this.getAttribute('min-days'), 10) || 3;
      const maxDays = parseInt(this.getAttribute('max-days'), 10) || 7;
      const locale = document.documentElement.lang || 'en';
      const today = new Date();

      const deliveryDate = this.addBusinessDays(today, maxDays);
      const formatter = new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      });

      const dateEl = this.querySelector('.shipping-info__delivery-date');
      if (dateEl) {
        dateEl.textContent = formatter.format(deliveryDate);
      }
    }
  }

  if (!customElements.get('shipping-info')) {
    customElements.define('shipping-info', ShippingInfo);
  }
  } catch(e) { console.error(e); }
})();

})();
